export class MessageParameters{
    recepients : string;
    template : string;
    parameters : any
    languageCode ? : string
    constructor (recepients:string,template:string, parameters :any,languageCode?:string) {
        this.recepients = recepients;
        this.template = template;
        this.parameters = parameters;
        this.languageCode = languageCode
    }
}